import { render } from "./Proportiongradienttwo.vue?vue&type=template&id=2e1b520f"
import script from "./Proportiongradienttwo.vue?vue&type=script&lang=js"
export * from "./Proportiongradienttwo.vue?vue&type=script&lang=js"

import "./Proportiongradienttwo.vue?vue&type=style&index=0&id=2e1b520f&lang=css"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__